import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';
import {emeaLegalLinks, determineLegalCountry} from '../../utils/helpers';

class EmeaFooter extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {
    const classNames = ['footerContainer'];

    const {euUkPrivacyPolicy, cookiePolicy, tou, countrySpecificPrivacyPolicy} = emeaLegalLinks(determineLegalCountry());

    classNames.push((this.props.hasChanges && this.props.userHasInteracted) ? 'showSave' : 'hideSave');
    return (
      <footer className={classNames.join(' ')}>
        <div className='footerLinksContainer'>
          <p>
            <span className='footerCopyright'>{this.translate('footerCopyright')}</span>
            {tou ?
              <React.Fragment>
                <span className='footerPipe pipe1'> |</span>
                <a id='termsOfUse-FooterLink' href={tou}
                   target='_blank'>{this.translate('footerTerms')}
                </a>
              </React.Fragment> : ''}

            {euUkPrivacyPolicy ?
              <React.Fragment>
                <span className='footerPipe pipe1'> |</span>
                <a id='euUkPrivacyPolicy-FooterLink' href={euUkPrivacyPolicy}
                   target='_blank'>{this.translate('euUkPrivacyPolicy')}
                </a>
              </React.Fragment> : ''}

            {countrySpecificPrivacyPolicy ?
              <React.Fragment>
                <span className='footerPipe pipe1'> |</span>
                <a id='countrySpecificPrivacyPolicy-FooterLink' href={countrySpecificPrivacyPolicy}
                   target='_blank'>{this.translate('privacyTitle')}
                </a>
              </React.Fragment> : ''}

            {cookiePolicy ?
              <React.Fragment>
                <span className='footerPipe pipe1'> |</span>
                <a id='cookiePolicy-FooterLink' href={cookiePolicy}
                   target='_blank'>{this.translate('cookiesPolicy')}
                </a>
              </React.Fragment> : ''}
            <span className='block' />
          </p>
        </div>
      </footer>
    );
  }
}

TranslatedComponent(EmeaFooter);
module.exports = EmeaFooter;



// WEBPACK FOOTER //
// ./client/src/components/footer/EmeaFooter.jsx